import React from 'react';
import Moment from 'react-moment';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPen} from '@fortawesome/free-solid-svg-icons';

import {Survey} from '../Services/SurveyService';

interface SurveyProps {
  survey: Survey;
}

function SurveyPreview({survey}: SurveyProps) {
  return (
    <div>
      <h4>{survey.title}<Link to={`/admin/surveys/${survey.id}`}> <FontAwesomeIcon icon={faPen} /></Link></h4>
      <p><Moment withTitle date={survey.date} /> - <Moment withTitle date={survey.expiry} /></p>
    </div>
  );
}

export default SurveyPreview;
